import styled from 'styled-components';
import { Section, SpacedElements } from '@elfsight/lib-stripe-integration';
import { getColorWithAlpha } from '@elfsight/lib-utils';
import { Typography } from '@elfsight/widget-ui';
import { createReadableClass } from '@elfsight/widget-utils';
import { useCheckoutI18n } from '../providers';
import { TextButton } from './text-button';

const COMPONENT_NAME = 'email-display-element';

type EmailDisplayElementProps = {
  textColor: string;
  accentColor: string;
  toEditMode: () => void;
  email?: string;
};

export function EmailDisplayElement({
  textColor,
  accentColor,
  toEditMode,
  email
}: EmailDisplayElementProps) {
  const { t } = useCheckoutI18n();
  const emailColor = getColorWithAlpha(textColor, 0.5);

  return (
    <DisplayComponent $withoutTopPadding $withoutBottomPadding $stretch>
      <StyledSpacedElements>
        <LabeledEmail color={textColor} textToken="text16">
          <Label>{t('Email for payment confirmation')}:</Label>{' '}
          <Email $color={emailColor}>{email}</Email>
        </LabeledEmail>
        <TextButton
          onClick={toEditMode}
          color={accentColor}
          className={createReadableClass({
            component: COMPONENT_NAME,
            element: 'edit-button'
          })}
        >
          {t('Change')}
        </TextButton>
      </StyledSpacedElements>
    </DisplayComponent>
  );
}

const DisplayComponent = styled(Section).attrs({
  className: createReadableClass({
    component: COMPONENT_NAME
  })
})`
  max-width: 100%;
`;

const StyledSpacedElements = styled(SpacedElements)`
  max-width: 100%;
  gap: 20px;
`;

const LabeledEmail = styled(Typography).attrs({
  className: createReadableClass({
    component: COMPONENT_NAME,
    element: 'labeled-email'
  })
})`
  flex: 1 1 auto;

  min-width: 0;
  max-width: 100%;
`;

const Label = styled.span.attrs({
  className: createReadableClass({
    component: COMPONENT_NAME,
    element: 'label'
  })
})``;

const Email = styled.span.attrs({
  className: createReadableClass({
    component: COMPONENT_NAME,
    element: 'email'
  })
})<{ $color: string }>`
  display: inline-block;
  vertical-align: bottom;

  max-width: 100%;

  color: ${({ $color }) => $color};

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
